import { SERVICEWORKER_SCOPE } from './registerWebPushServiceWorker';

export default async function getWebPushRegistration(
    windowObj: Window
): Promise<ServiceWorkerRegistration> {
    const serviceWorker: ServiceWorkerContainer = windowObj.navigator.serviceWorker;
    const registrations = await serviceWorker.getRegistrations();
    let webPushRegistration = null;
    const origin: string = windowObj.location.origin + SERVICEWORKER_SCOPE;
    for (let i = 0; i < registrations.length; ++i) {
        if (registrations[i].scope.toLowerCase() === origin) {
            webPushRegistration = registrations[i];
            break;
        }
    }

    return webPushRegistration;
}
